import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional classnames helper that also resolves overlapping tailwind classes
 */
export const cn = (...args: ClassValue[]) => twMerge(clsx(args));
